<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto" ref="scroller">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
      contentId="subscription"
    />

    <DataGetter
      contentId="kycData"
      @dataAvailable="
        data => {
          kycData = data?.metaData || {}
        }
      "
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Devenez Pro</div>
      <div class="flex gap-12 items-center">
        <div class="flex h-12 w-12 rounded-full overflow-hidden">
          <img
            :src="
              userData?.metaData?.rawUser?.metadata?.pictureUrl ||
              userData?.profilePictureUrl
            "
            class="w-full h-full"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row justify-center gap-8">
      <div
        class="rounded-t-[3rem] rounded-b-[0.8rem] md:rounded-l-[3rem] md:rounded-r-[0.8rem] p-8 bg-white border md:w-[35rem]"
      >
        <div class="flex flex-col h-full">
          <!-- <div class="w-16 h-16 rounded-xl border">
            <img
              src="https://placehold.co/240"
              alt=""
              class="w-full h-full object-contain"
            />
          </div> -->
          <div class="py-2"></div>
          <div>
            <button
              class="relative overflow-hidden rounded-full text-primary px-5 py-3 uppercase text-xl bg-primary-50"
            >
              <div
                class="top-0 left-0 absolute w-full h-full bg-gradient-to-r from-[#0000] to-[#F5FEFFaa]"
              ></div>
              Plan Basique
            </button>
          </div>
          <div class="py-2"></div>
          <div>
            <span class="text-5xl font-bold title-color"> 0 FCFA </span>
            <span class="text-sm"> /mois </span>
          </div>
          <div class="py-2"></div>
          <div class="description-color text-lg">
            Benéficiez des fonctionalités basqiues de marketplace et commencez
            par vendre dès maintenant
          </div>
          <div class="py-4"></div>
          <div class="border-b"></div>
          <div class="py-3"></div>
          <div class="flex gap-4 flex-col">
            <div
              class="flex items-center gap-4 text-lg"
              v-for="(option, i) in pricingOptions.simple"
              :key="i"
            >
              <div
                class="w-8 h-8 min-w-8 rounded-full"
                :class="{
                  'bg-red-100': !option.isIncluded,
                  'bg-green-100': option.isIncluded,
                }"
              >
                <img
                  src="@/assets/images/all/close-red.svg"
                  alt=""
                  class="w-full h-full p-2.5 opacity-60"
                  v-if="!option.isIncluded"
                />
                <img
                  src="@/assets/images/all/check-normal-primary.svg"
                  v-else
                  alt=""
                  class="w-full h-full p-1.5"
                />
              </div>
              <div
                :class="{
                  'line-through opacity-50': !option.isIncluded,
                }"
              >
                {{ option.name }}
              </div>
            </div>
          </div>
          <div class="py-4"></div>
          <div class="w-full mt-auto">
            <button
              class="buttonComponent text-xl rounded-full w-full text-primary bg-primary-50"
            >
              Offre actuelle
            </button>
          </div>
          <div class="py-4"></div>
        </div>
      </div>
      <div
        class="relative rounded-b-[3rem] rounded-t-[0.8rem] md:rounded-r-[3rem] md:rounded-l-[0.8rem] p-8 bg-[#1E0C52] text-primary-200 max-w-[35rem]"
      >
        <div class="">
          <!-- <div class="w-16 h-16 rounded-xl border">
            <img
              src="https://placehold.co/240"
              alt=""
              class="w-full h-full object-contain"
            />
          </div> -->
          <div class="py-2"></div>
          <div>
            <button
              class="relative uppercase overflow-hidden rounded-full text-white px-5 py-3 text-xl bg-primary-50"
            >
              <div
                class="top-0 left-0 absolute w-full h-full bg-gradient-to-tr from-[#aB5DFE] to-[#09BAFF]"
              ></div>
              <div class="relative">EkiDiscount Pro</div>
            </button>
          </div>
          <div class="py-2"></div>
          <div>
            <span class="text-5xl font-bold text-white"> 10.000 FCFA </span>
            <span class="text-sm"> /mois </span>
          </div>
          <div class="py-2"></div>
          <div class="text-lg">
            Prenez en main complètement marketplace. Utilisez des
            fonctionalitées avancées pour augmentez vos ventes
          </div>
          <div class="py-4"></div>
          <div class="border-b"></div>
          <div class="py-3"></div>
          <div class="flex gap-4 flex-col">
            <div
              class="flex items-center gap-4 text-lg"
              v-for="(option, i) in pricingOptions.pro"
              :key="i"
            >
              <div
                class="w-8 h-8 min-w-8 rounded-full"
                :class="{
                  'bg-[#642CFF]': !option.isIncluded,
                  'bg-[#642CFF]': option.isIncluded,
                }"
              >
                <img
                  src="@/assets/images/all/close-red.svg"
                  alt=""
                  class="w-full h-full p-2.5 opacity-60"
                  v-if="!option.isIncluded"
                />
                <img
                  src="@/assets/images/all/check-normal-white.svg"
                  v-else
                  alt=""
                  class="w-full h-full p-1.5"
                />
              </div>
              <div
                :class="{
                  'line-through opacity-50': !option.isIncluded,
                }"
              >
                {{ option.name }}
              </div>
            </div>
          </div>
          <div class="py-4"></div>
          <div class="w-full">
            <button
              @click="activatePro"
              class="buttonComponent text-xl rounded-full w-full bg-gradient-to-tr from-[#aB5DFE] to-[#09BAFF]"
            >
              Devenir Pro
            </button>
          </div>
          <div class="py-4"></div>
        </div>
        <div
          class="absolute w-full h-full top-0 left-0 opacity-[0.15] pointer-events-none"
          data-v-43198946
        >
          <svg
            viewBox="0 0 100% 100%"
            xmlns="http://www.w3.org/2000/svg"
            class="w-full h-full"
            data-v-43198946
          >
            <filter id="noiseFilter" data-v-43198946>
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.65"
                numOctaves="3"
                stitchTiles="stitch"
                data-v-43198946
              ></feTurbulence>
            </filter>
            <rect
              width="100%"
              height="100%"
              filter="url(#noiseFilter)"
              data-v-43198946
            ></rect>
          </svg>
        </div>
      </div>
    </div>

    <EventListener
      :events="[
        'pro_subscription_payment_launched',
        'failed_to_launch_pro_subscription_payment',
        'transaction_url_available',
        'collection_finished_available',
        'iframe_closed',
      ]"
      @pro_subscription_payment_launched="onPaymentLaunched"
      @failed_to_launch_pro_subscription_payment="onPaymentFailedToLaunch"
      @transaction_url_available="onPaymentUrlAvailable"
      @collection_finished_available="onPaymentFinished"
      @iframe_closed="onIframeClosed"
    />
  </div>
</template>

<script>
import UserProperty from '@/components/user/UserProperty.vue'
import EventListener from '@/components/utils/EventListener.vue'
import DataGetter from '@/components/utils/DataGetter.vue'

export default {
  name: 'homeComponent',
  components: {
    UserProperty,
    EventListener,DataGetter
  },
  data() {
    return {
      userData: {},
      subscription: {},
      kycData: {},
      eventsIds: [],
      pricingOptions: {
        simple: [
          {
            name: 'Boutique personnalisée (design simple)',
            isIncluded: true,
          },
          {
            name: "Nombre limité de produits (jusqu'à 10)",
            isIncluded: true,
          },
          {
            name: 'Commission de 5 % par vente',
            isIncluded: true,
          },
          {
            name: 'Support standard (email uniquement)',
            isIncluded: true,
          },
        ],
        pro: [
          {
            name: 'Boutique entièrement personnalisable (thèmes personnalisés)',
            isIncluded: true,
          },
          // {
          //   name: 'Promotion',
          //   isIncluded: true,
          // },
          {
            name: 'Nombre de produits : illimité',
            isIncluded: true,
          },
          {
            name: 'Commission de 3 % par vente',
            isIncluded: true,
          },
          {
            name: 'Outils marketing intégrés (Promotion, SEO)',
            isIncluded: true,
          },
          {
            name: 'Support 24/7 avec gestionnaire de compte dédié par chat',
            isIncluded: true,
          },
        ],
      },
      latestTransactionUrl: '',
      latestTransactionId: '',
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {
    this.$refs.scroller.scrollTo(0, 1000)
  },
  methods: {
    async activatePro() {
      if (!this.kycData?.isValidated) {
        this.handleKycRequired()
        return
      }
      const prompt = await window.choicePrompt({
        title: 'Comment voulez vous faire le paiement?',
        options: [
          {
            title: 'Payer par mobile money',
            id: 'mobileMoney',
          },
          {
            title: 'Payer par carte bancaire',
            id: 'card',
          },
        ],
        formatDisplay: data => data?.title || '',
        successText: 'Payer',
      })
      if (!prompt.accepted || !prompt.data) return null
      // return prompt.data.name
      await new Promise(r => setTimeout(r, 500))
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('pro_subscription_payment_required', {
        paymentMethod: prompt.data.id,
      })
      this.listenLaunchedTransaction = true
    },
    handleKycRequired() {
      let routeToKyc = true
      let message =
        'Vous devez valider votre compte pour avoir accès à Ekidiscount pro'
      if (this.kycData?.isPending || this.kycData?.isPending) {
        routeToKyc = false
        message =
          'Veuillez patienter pendant la validation de votre compte pour activer Ekidiscount pro'
      } else if (this.kycData?.isRejected) {
        message =
          ' Votre compte a été rejeté, veuillez remplire à nouveau les informations'
      }
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Compte non validé',
        body: message,
      })
      if (routeToKyc) this.$router.push('/validation')
    },
    onPaymentLaunched() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement lancé',
        body: 'La paiement a été lancé. Veuillez patienter et confirmer',
      })
    },
    onPaymentFailedToLaunch() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement non lancé',
        body: "Echec d'initiation du paiement, veuillez réessayer.",
      })
    },
    onPaymentUrlAvailable({ url, id }) {
      if (!this.listenLaunchedTransaction) return
      console.log(id)
      this.listenLaunchedTransaction = false
      this.latestTransactionUrl = url
      this.latestTransactionId = id
      this.$Events.dispatchEvent('url_opening_required', {
        url: url,
        useIframe: true,
        iframeClasses: 'w-full h-full',
      })
    },
    onPaymentFinished({ id, status }) {
      console.log(id, this.latestTransactionId)
      if (id == this.latestTransactionId) {
        this.$Events.dispatchEvent('close_iframe')
        this.$Events.dispatchEvent('subscription_payment_done')
        this.latestTransactionId = ''
        this.latestTransactionUrl = ''
        if (status == 'success') {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Paiement réussi',
            body: 'Votre abonnement a réussi',
          })
          setTimeout(() => {
            window.location.reload()
          }, 5000)
        } else {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Echec du paiement',
            body: "Le paiement de votre abonnement n'a pas réussi, veuillez réessayer",
          })
        }
      }
    },
    onIframeClosed({ url }) {
      console.log('iframe closedd', url, this.latestTransactionUrl)
      if (url !== this.latestTransactionUrl) return
      this.latestTransactionId = ''
      this.latestTransactionUrl = ''
      this.listenLaunchedTransaction = false
    },
  },
  watch: {
    subscription: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal.isActive) return
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Vous êtes déjà passé pro',
          body: 'Profitez des avantages de Ekidiscount pro',
        })
        this.$router.push('/')
      },
    },
  },
}
</script>
